'use client';

import DailyBonus from '@/components/entities/dailyBonus';
import { cn } from '@/utils/cn';
import { useUnclaimedGamificationRewardsCount } from '../../modules/rewards/hooks/useUnclaimedGamificationRewardsCount';
import { GamificationRewardsGrid } from './GamificationRewardsGrid';

interface GamificationRewardsContentProps {
  className?: string;
}

export const GamificationRewardsContent = ({ className }: GamificationRewardsContentProps) => {
  const { countOfRewardsWithoutDaily } = useUnclaimedGamificationRewardsCount();

  return (
    <div className={cn('flex flex-col gap-5 md:gap-6', className)}>
      <DailyBonus appearance="rewards-page" />
      <GamificationRewardsGrid countOfGamificationRewards={countOfRewardsWithoutDaily} />
    </div>
  );
};
